import React, { useState, useEffect } from 'react';
import { Container, Card, Badge, Alert, Spinner } from 'react-bootstrap';
import { QuestionCircle } from 'react-bootstrap-icons';
import { SimpleSection } from '../components/Section';
import { formatDateTime } from '../utils/dateUtils';
import config from '../config';

const AnswersPage = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchPublishedQuestions();
  }, []);

  const fetchPublishedQuestions = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.api.url}questions/published`);
      
      if (response.ok) {
        const data = await response.json();
        setQuestions(data.questions || []);
      } else {
        throw new Error('Failed to fetch published questions');
      }
    } catch (err) {
      console.error('Error fetching published questions:', err);
      setError('Failed to load answers. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="my-4">
        <div className="text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-2">Loading answers...</p>
        </div>
      </Container>
    );
  }

  return (
    <>
      <SimpleSection>
        <h1>
          Answers to Common Questions
        </h1>
        <p className="text-muted">
          Find answers to frequently asked questions about the Quantum City Challenge.
        </p>
      </SimpleSection>

      <SimpleSection>
        {error && (
          <Alert variant="danger" className="mb-4">
            {error}
          </Alert>
        )}

        {questions.length === 0 ? (
          <Card>
            <Card.Body className="text-center py-5">
              <h4>No Published Answers Yet</h4>
              <p className="text-muted">
                Answers to common questions will be posted here.
              </p>
            </Card.Body>
          </Card>
        ) : (
          <div className="questions-list">
            {questions.map((question) => (
              <Card key={question.questionId} className="mb-4">
                <Card.Header>
                  <div className="d-flex justify-content-between align-items-start">
                    <h5 className="mb-1">{question.title}</h5>
                    <Badge bg="secondary">{question.track || 'General'}</Badge>
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className="mb-3">
                    <h6 className="text-muted">Question:</h6>
                    <div dangerouslySetInnerHTML={{ __html: question.question }} />
                  </div>
                  
                  <div className="mb-3">
                    <h6 className="text-success">Answer:</h6>
                    <div dangerouslySetInnerHTML={{ __html: question.answer }} />
                  </div>
                  
                  <div className="text-muted small">
                    Answered on {formatDateTime(question.answeredAt)}
                  </div>
                </Card.Body>
              </Card>
            ))}
          </div>
        )}
      </SimpleSection>
    </>
  );
};

export default AnswersPage;
